import { theme } from '@lomadee/design-system';
import { MARY_KAY_WHITELABEL } from '@plug/config/consts';
import getCustomizatedColor from '@plug/helpers/get-customizated-color';
import { ComponentProps } from 'react';
import { Flex, Text } from 'rebass';
import styled, { css } from 'styled-components';

export const ContainersBox = styled.div`
  display: flex;
  min-height: 100%;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  flex: 1;
  margin: auto;

  height: 100vh;
  width: 100%;

  @media screen and (max-width: 768px) {
    height: 100%;
  }
`;

export const WrappedElements = styled.div`
  position: relative;
  height: 100vh;

  @media screen and (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;

  & > button {
    display: none;
  }

  @media screen and (max-width: 767px) {
    justify-content: space-between;
    align-items: center;

    & > button {
      display: unset;
    }
  }
`;

export const LeftContainer = styled.div<
  ComponentProps<'div'> & { olist: boolean; isEfizi?: boolean }
>`
  height: 100%;
  background-color: ${({ theme, olist }) => (olist ? '#ffffff' : theme.colors.primaryDark)};
  overflow: hidden;

  ${({ theme, isEfizi }) =>
    isEfizi &&
    css`
      background-color: ${() => (isEfizi ? '#ff5414' : theme.colors.primaryDark)};
    `}

  ${({ olist, isEfizi }) =>
    !isEfizi &&
    !olist &&
    css`
      background-color: ${getCustomizatedColor(
        'leftSideOnboardingColor',
        theme.colors.primaryDark,
      )} !important;
    `}

  ${() =>
    MARY_KAY_WHITELABEL.includes(window.location.hostname) &&
    css`
      div {
        color: #333;
      }
    `}

  @media screen and (max-width: 767px) {
    height: ${({ olist }) => (olist ? '120px' : '224px')};
    overflow: unset;
  }
`;

export const LeftContainerElements = styled.div`
  display: flex;
  height: 60%;
  width: 60%;
  max-width: 400px;
  gap: 16px;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const FooterLogo = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const RightContainerElements = styled.div`
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  padding: 72px 13%;

  @media screen and (max-width: 767px) {
    margin: 40px auto;
    padding: 0 24px;
    width: 100%;
    overflow-y: hidden;
  }
`;

export const OnlyDesktopText = styled(Text)`
  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

export const OnlyDesktopFlex = styled(Flex)`
  @media screen and (max-width: 1023px) {
    display: none;
    * {
      display: none;
    }
  }
`;
